<div *ngIf="!isLoading">
	<div class="confirm-cart-block" *ngIf="notAgreedLegalDocumentIds.length === 0">
		<span translate>legal-documents.confirm.cart.with.sales.conditions</span>&nbsp;
		<a target="_blank" [routerLink]="['/legal-informations']" > {{ legalDocumentLabel }}</a>&nbsp;
		<span translate>legal-documents.and</span>&nbsp;
		<a target="_blank" [routerLink]="['/legal-informations']" translate>legal-documents.general.sales.conditions</a>
	</div>

	<div class="confirm-cart-block" *ngIf="notAgreedLegalDocumentIds.length > 0">
		<mat-checkbox (change)="onAgreementCheckboxChange($event.checked)">
			<span class="checkbox-label-wrapped" translate>legal-documents.agree.to.sales.conditions</span>&ngsp;
			<a target="_blank" [routerLink]="['/legal-informations']" > {{ legalDocumentLabel }}</a>&ngsp;
			<span translate>legal-documents.and</span>&ngsp;
			<a target="_blank" [routerLink]="['/legal-informations']" translate>legal-documents.general.sales.conditions</a>
		</mat-checkbox>
	</div>
</div>